/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import styles from "../Styles/dashboard.module.css";
import { Vocabulary } from "../Utils/Vocabulary";
import { urlEnum } from "../Utils/UrlEnum";
import MainTable from "../Components/GenericComponents/MainTable";
import { useState } from "react";
import { CustomerModel, Location, VendorModel, PartnerModel } from "../Utils/Models";
import { updateData } from "../Services/updateData";
import { postData } from "../Services/postData";
import CustomerMainPage from "../Components/Customers/CustomerMainPage";
import { Box, createTheme, ThemeProvider } from "@mui/material";
import MUIDataTable from "mui-datatables";

type CustomersProps = {
  title: string;
};
export default function Customers(props: CustomersProps) {
  const { title } = props;
  const [open, setOpen] = useState(false);
  const [editItem, setEditItem] = useState<CustomerModel | null>(null);
  const [shouldUpdate, setShouldUpdate] = useState(false);
  const queryParams = new URLSearchParams(window.location.search);
  const type = queryParams.get("type"); // Get the 'type' query parameter

  const customersHeader = [
    {
      label: Vocabulary.name,
      name: "name",
      options: { sort: false },
    },
    {
      label: Vocabulary.company,
      name: "companyName",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.phone,
      name: "phone",
      options: {
        sort: false,
      },
    },
    {
      label: Vocabulary.email,
      name: "email",
      options: {
        sort: false,
      },
    },
  ];
  /**
   *
   * @param item
   */
  function handleEdit(item: CustomerModel | null) {
    setShouldUpdate(false);
    setOpen(!open);
    setEditItem(item);
  }
  /**
   *
   * @param step
   */
  function addOrUpdateCustomer(customer: CustomerModel | VendorModel | PartnerModel | null) {
    const username = localStorage.getItem("userName");
    if (customer && username) {
      customer.username = username;
    }
    if (type === "customers") {
      if (customer?._id) {
        updateData(`${urlEnum.customerCrm}/${customer._id}`, customer)
          .then((res) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      } else {
        postData(`${urlEnum.customerCrm}/crm`, customer)
          .then((res: any) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      }
    } else if (type === "vendors") {
      const formatedCustomer = {
        ...customer,
        isVendor: true,
        isPartner: false,
      };
      if (customer?._id) {
        updateData(`${urlEnum.customers}/${customer._id}`, formatedCustomer)
          .then((res) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      } else {
        postData(`${urlEnum.customers}`, formatedCustomer)
          .then((res: any) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      }
    } else if (type === "partners") {
      const formatedCustomer = {
        ...customer,
        isVendor: false,
        isPartner: true,
      };
      if (customer?._id) {
        updateData(`${urlEnum.customers}/${customer._id}`, formatedCustomer)
          .then((res) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      } else {
        postData(`${urlEnum.customers}`, formatedCustomer)
          .then((res: any) => {
            if (res) {
              setOpen(false);
              setShouldUpdate(true);
            }
          })
          .catch((err) => {
            setOpen(false);
          });
      }
    }
  }
  const locationColumns = [
    { label: "City", name: "city", options: { sort: false } },
    { label: "County", name: "county", options: { sort: false } },
    { label: "Country", name: "country", options: { sort: false } },
    { label: "Details", name: "details", options: { sort: false } },
    { label: "Postal Code", name: "postalCode", options: { sort: false } },
    { label: "Bank", name: "bank", options: { sort: false } },
    { label: "IBAN", name: "iban", options: { sort: false } },
    { label: "First Name", name: "firstName", options: { sort: false } },
    { label: "Last Name", name: "lastName", options: { sort: false } },
    { label: "Email", name: "email", options: { sort: false } },
    { label: "Phone", name: "phone", options: { sort: false } },
  ];

  const formatLocationsData = (data: Location[]) => {
    const array: any = [];
    data.forEach((location) => {
      const formattedLocation = {
        city: location.address.city,
        county: location.address.county,
        country: location.address.country,
        details: location.address.details,
        postalCode: location.address.postcode,
        bank: location.bank,
        iban: location.iban,
        firstName: location.contactPerson.firstName,
        lastName: location.contactPerson.lastName,
        email: location.contactPerson.email,
        phone: location.contactPerson.phone,
      };
      array.push(formattedLocation);
    });
    return array;
  };

  const locationsTypesTheme = createTheme({
    components: {
      MuiToolbar: {
        styleOverrides: {
          root: {
            backgroundColor: "none",
          },
        },
      },
    },
  });
  const responsive: "standard" | "vertical" | "simple" | undefined = "standard";
  return (
    <div className={styles.mainContainerUser}>
      <MainTable
        urlEnumApi={
          type === "customers"
            ? `${urlEnum.customerCrm}`
            : `${urlEnum.customers}`
        }
        header={customersHeader}
        tableTitle={title}
        deleteMessages={{
          title: Vocabulary.deleteCustomer,
          text: Vocabulary.deleteConfirmationCustomer,
        }}
        shouldUpdate={shouldUpdate}
        handleEdit={handleEdit}
        tableCustomOptions={{ expandableRows: true }}
        renderExpandableRow={(
          rowData: any,
          rowMeta: any,
          item: CustomerModel
        ) => (
          <tr
            style={{
              backgroundColor: "#ccc",
              borderRadius: "13px",
              border: "1px solid #ccc",
            }}
          >
            <td colSpan={rowData.length + 1}>
              <Box sx={{ padding: "5px" }}>
                <ThemeProvider theme={locationsTypesTheme}>
                  <MUIDataTable
                    title={null}
                    columns={locationColumns}
                    data={formatLocationsData(item.locations)}
                    options={{
                      responsive: responsive,
                      selectableRows: "none",
                      search: false,
                      filter: false,
                      print: false,
                      download: false,
                      viewColumns: false,
                      customFooter: () => null,
                    }}
                  />
                </ThemeProvider>
              </Box>
            </td>
          </tr>
        )}
        isRowExpandable={(dataIndex, expandedRows, data: CustomerModel[]) => {
          const item = data[dataIndex].isLegalPerson;
          return item;
        }}
      />
      {open ? (
        <CustomerMainPage
          title={
            title === Vocabulary.vendorsList
              ? Vocabulary.vendors
              : title === Vocabulary.partnersList
                ? Vocabulary.partners
                : title === Vocabulary.customersList
                  ? Vocabulary.customers
                  : title
          }
          editCustomer={editItem}
          open={open}
          addOrUpdateCustomer={(customer) => addOrUpdateCustomer(customer)}
          onClose={() => handleEdit(null)}
          fromOrder={false}
        />
      ) : null}
    </div>
  );
}
